import { MEDIA_BUFFER_STATUSES } from '../constants/MediaBufferStatus';
export const PlayerStatuses = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  ENDED: 'ENDED',
  ERROR: 'ERROR'
};
export const mediaPlaybackActions = {
  reset: state => ({
    type: 'RESET',
    state
  }),
  setStatus: status => ({
    type: 'SET_STATUS',
    status
  }),
  setErrorStatus: errorType => ({
    type: 'SET_ERROR_STATUS',
    errorType
  }),
  setCurrentTime: currentTime => ({
    type: 'SET_CURRENT_TIME',
    currentTime
  }),
  setClipEndTime: time => ({
    type: 'SET_CLIP_END_TIME',
    time
  }),
  setClipStartTime: time => ({
    type: 'SET_CLIP_START_TIME',
    time
  }),
  loadedMetadata: duration => ({
    type: 'LOADED_METADATA',
    duration
  }),
  setRefetchedMediaUrl: refetchedMediaUrl => ({
    type: 'SET_REFETCHED_MEDIA_URL',
    refetchedMediaUrl
  }),
  setMaybeRequiresAuthUpdate: maybeRequiresAuthUpdate => ({
    type: 'SET_MAYBE_REQUIRES_AUTH_UPDATE',
    maybeRequiresAuthUpdate
  }),
  setPercentLoaded: percentLoaded => ({
    type: 'SET_PERCENT_LOADED',
    percentLoaded
  }),
  setPlaybackRequested: playbackRequested => ({
    type: 'SET_PLAYBACK_REQUESTED',
    playbackRequested
  }),
  setBufferStatus: bufferStatus => ({
    type: 'SET_BUFFER_STATUS',
    bufferStatus
  })
};
export const mediaPlaybackReducer = (state, action) => {
  switch (action.type) {
    case 'SET_STATUS':
      if (state.playbackRequested && ['PLAYING', 'PAUSED', 'ERROR'].includes(action.status)) {
        return Object.assign({}, state, {
          status: action.status,
          playbackRequested: false
        });
      }
      return Object.assign({}, state, {
        status: action.status
      });
    case 'SET_ERROR_STATUS':
      return Object.assign({}, state, {
        status: PlayerStatuses.ERROR,
        bufferStatus: MEDIA_BUFFER_STATUSES.INITIAL,
        errorType: action.errorType
      });
    case 'LOADED_METADATA':
      if (!isNaN(action.duration) && isFinite(action.duration)) {
        state.preciseDuration = action.duration;
        state.roundedDuration = Math.floor(action.duration);
      }
      return Object.assign({}, state);
    case 'SET_CURRENT_TIME':
      return Object.assign({}, state, {
        bufferStatus: MEDIA_BUFFER_STATUSES.INITIAL,
        currentTime: action.currentTime
      });
    case 'SET_CLIP_END_TIME':
      return Object.assign({}, state, {
        clipEndTime: action.time
      });
    case 'SET_CLIP_START_TIME':
      return Object.assign({}, state, {
        clipStartTime: action.time
      });
    case 'RESET':
      return Object.assign({}, action.state);
    case 'SET_REFETCHED_MEDIA_URL':
      return Object.assign({}, state, {
        refetchedMediaUrl: action.refetchedMediaUrl
      });
    case 'SET_MAYBE_REQUIRES_AUTH_UPDATE':
      return Object.assign({}, state, {
        maybeRequiresAuthUpdate: action.maybeRequiresAuthUpdate
      });
    case 'SET_PERCENT_LOADED':
      return Object.assign({}, state, {
        bufferStatus: MEDIA_BUFFER_STATUSES.INITIAL,
        percentLoaded: action.percentLoaded
      });
    case 'SET_PLAYBACK_REQUESTED':
      return Object.assign({}, state, {
        playbackRequested: action.playbackRequested
      });
    case 'SET_BUFFER_STATUS':
      return Object.assign({}, state, {
        bufferStatus: action.bufferStatus
      });
    default:
      return state;
  }
};